import { Divider, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup, MenuItem, Button } from '@chakra-ui/react'
import { ChevronDownIcon } from '@chakra-ui/icons'
import { useMemo, useState } from 'react'

const SUMMARY_COLUMNS = [
    { value: 'counted_amount', label: 'כמות פריטים שנספרה' },
    { value: 'expectations_amount', label: 'חנות מלאי' },
    { value: 'counted_amounts_by_group', label: 'כמות פריטים שנספרה לפי קבוצות' },
    { value: 'gap', label: 'הפרש כמות' },
    { value: 'money_gap_buy', label: 'הפרש מחיר עלות' },
    { value: 'money_gap_sell', label: 'הפרש מחיר מכירה' },
    { value: 'unmatched_counted_amount', label: 'כמות פריטים שנספרו ולא נמצאים בדוח הפרשים' },
]

const SupplyGapSelect = ({ baseURL, countingId, keyBy }) => {
    const [columns, setColumns] = useState(SUMMARY_COLUMNS.map((column) => column.value))

    const href = useMemo(() => {
        const base = (baseURL || '').replace(/\/$/, '')
        const params = new URLSearchParams({ keyBy })
        const allColumnsSelected = SUMMARY_COLUMNS.every((column) => columns.includes(column.value))
        if (!allColumnsSelected) {
            params.set('columns', columns.join(','))
        }
        return `${base}/counting/expectations/${countingId}/summary?${params}`
        }, [baseURL, countingId, keyBy, columns])

    const hasColumns = columns.length > 0

return (
    <Menu closeOnSelect={false} placement='bottom-end'>
        <MenuButton as={Button} size='sm' colorScheme='teal' rightIcon={<ChevronDownIcon />} ml='auto' flexShrink={0}>
            Download Summary PDF
        </MenuButton>
        <MenuList dir='rtl' maxW='320px' fontSize='sm'>
            <MenuOptionGroup title='Select columns' type='checkbox' value={columns} onChange={setColumns}>
                {SUMMARY_COLUMNS.map((column) => (
                <MenuItemOption key={column.value} value={column.value}>
                    {column.label}
                </MenuItemOption>
                ))}
            </MenuOptionGroup>
            <Divider/>
                <MenuItem as='a' 
                    href={hasColumns ? href : undefined}
                    target='_blank'
                    rel='noopener noreferrer'
                    closeOnSelect
                    isDisabled={!hasColumns}
                    fontWeight='semibold'>
                        Download ({columns.length}/{SUMMARY_COLUMNS.length})
                </MenuItem>
        </MenuList>
    </Menu>
)
}

export default SupplyGapSelect